//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { Deployment } from "../../api/lib";

export const isArangoPlatformEnabledForDeployment = (deployment: Pick<Deployment, "arangodb_platform_bundle">, isArangoPlatformFeatureEnabled: boolean) => {
  const bundle = (deployment.arangodb_platform_bundle || "").trim();
  return isArangoPlatformFeatureEnabled && !!bundle && bundle !== "coredb";
};

export const getDatabaseUiUrl = (endpointDefault: string | undefined, isArangoPlatformEnabled: boolean) =>
  isArangoPlatformEnabled ? `${endpointDefault}/ui/` : endpointDefault;
